/** True while the person is typing (input, textarea, select, contenteditable): single-key shortcuts stay out of the way. */
export function isTypingTarget(t: EventTarget | null): boolean {
  if (!(t instanceof HTMLElement)) return false;
  return t.isContentEditable || !!t.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])');
}

/** Apple keyboards: shortcuts are shown with ⌘ instead of Ctrl. */
export const isApplePlatform = () => typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/i.test((navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ?? navigator.platform ?? navigator.userAgent);
